const pixInitiationType = {
  MANUAL: 'MANUAL',
  DICT: 'DICT',
  STATIC_QRCODE: 'STATIC_QRCODE',
  DYNAMIC_QRCODE: 'DYNAMIC_QRCODE'
};

module.exports = pixInitiationType;
